<template>
  <div>
    <v-container class="pa-0" fluid>
  <v-row class="pl-0">
  <v-card :style="{'background-color':$vuetify.theme.themes.light.primary, width: '100%'}" id="footer" class="pl-0 pt-2 mt-0" inset elevation="0" >

      <v-row dense  justify="space-between" justify-sm="center" align="center">
        <v-col cols="6" class="text-sm-center text-xs-left" >
          <language-picker></language-picker>
        </v-col>
        <v-col cols="6" class="text-sm-center text-xs-right">
          <a :class="window.innerWidth < 340 && $i18n.locale ==='es-ES'?'':'mr-2'" style="color:white"
            href="#"
             color="white"
            @click.prevent.stop="showIt('privacy')">{{$tf('Privacy')}}</a>
          <a style="color:white"
            href="#"
            @click.prevent.stop="showIt('terms')">{{$tf('Terms')}}</a>
        </v-col>
        <v-col cols="12" class="text-xs-center mt-2"><span class="white--text">{{$tf('CopyrightNotice', {year: new Date().getFullYear()})}}</span></v-col>
      </v-row>
  </v-card>
  </v-row>
    </v-container>
    <v-dialog v-model="showDialog" max-width="800px">
      <terms v-if="dialog ==='terms'"></terms>
      <policy v-if="dialog ==='privacy'"></policy>
    </v-dialog>
  </div>
</template>

<script>
import LanguagePicker from './LanguagePicker'
import dialogs from '../../mixins/dialogs'
import Terms from '../dialogs/Terms'
import Policy from '../dialogs/Policy'
export default {
  name: 'idp-footer',
  components: { LanguagePicker, Terms, Policy },
  mixins: [dialogs],
  data () {
    return {
      window: window
    }
  }
}
</script>

<style lang="scss">
  footer {
    min-height: 72px;
    padding-left: 0!important;
  }
</style>
